import { HubConnectionBuilder } from "@microsoft/signalr";
import { useEffect, useState } from "react";
import { useProjectContext, useUserContext } from "../providers";
import { getAccessToken } from "@/services/helpers";

const useCommentHub = (reloadData) => {
  const [hub, setHub] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const { userToken } = useUserContext();
  const { project } = useProjectContext();

  // Create the hub on initial mount
  useEffect(() => {
    if (userToken && userToken.user) {
      const hub = new HubConnectionBuilder()
        .withUrl("/Hubs/CommentHub", {
          accessTokenFactory: async () => (await getAccessToken()) ?? "",
        })
        .withAutomaticReconnect()
        .build();

      hub.start().then((result) => {
        hub.on("ReceiveMessage", (projectId, message) => {
          console.log("ReceiveMessage", projectId, message);
          if (project.id === projectId && message === "comment") {
            reloadData();
          }
        });
      });

      setHub(hub);
    }
  }, [userToken, reloadData, project]);

  // After the hub is created, start it.
  // When the component unmounts, stop the hub so we don't keep sockets open forever.
  useEffect(
    () => () => {
      if (hub) {
        setIsConnected(false);
        hub.stop();
      }
    },
    [hub]
  );

  return [hub, isConnected];
};

export default useCommentHub;
